import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useLanguage } from "../../context/LanguageContext";

const GlobalStage = () => {
  const theme = useTheme();
  const isMobileQuery = useMediaQuery(theme.breakpoints.down("md"));
  const [isMobile, setIsMobile] = useState(null); // null for initial render
  const { language, toggleLanguage, translations } = useLanguage();

  // Ensure value is client-only (no SSR hydration mismatch)
  useEffect(() => {
    setIsMobile(isMobileQuery);
  }, [isMobileQuery]);

  const statsRow1 = [
    {
      value: translations[language]?.globeNumber,
      label: translations[language]?.globeNumber2,
    },
    {
      value: translations[language]?.globeNumber3,
      label: translations[language]?.globeNumber4,
    },
  ];

  const statsRow2 = [
    {
      value: translations[language]?.globeNumbers,
      label: translations[language]?.globeNumber5,
    },
    {
      value: translations[language]?.globeNumber6,
      label: translations[language]?.globeNumber7,
    },
  ];

  const videoSrc =
    isMobile === null
      ? null
      : isMobile
        ? "/Images/newMobileClobe.mp4"
        : "/Images/zzzzz.mp4";

  const renderStatRow = (stats, rowIndex) => (
    <Grid
      container
      spacing={rowIndex === 1 ? 9 : 4}
      sx={{
        marginTop: rowIndex === 0 ? "1.5rem" : "2rem",
      }}
    >
      {stats.map((item, index) => (
        <Grid item xs={6} key={index}>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: 2,
              marginLeft: "-1.1rem",
              padding: "1rem 3rem 0rem 0rem",
            }}
          >
            <Box
              sx={{
                width: "3px",
                height: "100%",
                backgroundColor: "#3b82f6",
                borderRadius: "2px",
              }}
            />
            <Box
              sx={{
                borderLeft: "2px solid rgba(25, 171, 226, 1)",
                pl: 2,
                ...(item.label === "Regulated Licenses" && {
                  ml: { xs: "0px", md: "-12px" },
                }),
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "22px !important", md: "30px" },
                  color: "#fff",
                }}
              >
                {item.value}
              </Typography>
              <Typography
                sx={{
                  color: "#ffffff7a",
                  fontSize: "16px",
                  fontWeight: "400",
                  pt: 1,
                }}
              >
                {item.label}
              </Typography>
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        minHeight: "100vh",
        height: "100%",
      }}
    >
      {/* Background Video */}
      {videoSrc && (
        <Box
          component="video"
          autoPlay
          loop
          muted
          playsInline
          key={videoSrc} // force re-render when src changes
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: -1,
          }}
        >
          <source src={videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </Box>
      )}

      {/* Content */}
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-between",
          alignItems: "center",
          px: { xs: 2, sm: 4, md: 11 },
          py: { xs: 6, md: 12 },
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Left Section */}
        <Box sx={{ flex: 1, maxWidth: "690px" }}>
          <Typography
            variant="subtitle2"
            sx={{ color: "#19ABE2", fontWeight: 500, mb: 1, ml: -1 }}
          >
            {translations[language]?.globeHead}
          </Typography>

          <Typography
            variant="h2"
            sx={{
              fontWeight: 600,
              mb: 2,
              fontSize: { xs: "30px", md: "52px" },
              lineHeight: { xs: "36px", md: "55px" },
              color: "#fff",
            }}
          >
            {translations[language]?.globeTitle}
          </Typography>

          <Typography sx={{ color: "#fff", mb: 4, mt: 4, fontWeight: 400 }}>
            {translations[language]?.globeDesc}
          </Typography>

          {/* Stat Rows */}
          {renderStatRow(statsRow1, 0)}
          {renderStatRow(statsRow2, 1)}

          <Button
            href="https://portal.bbcorp.trade/auth/jwt/sign-up"

            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            sx={{
              mt: 6,
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              color: "#fff",
              px: 4,
              py: 1.5,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 500,
              boxShadow: "none",
              ":hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                boxShadow: "none",
                color: "#fff",
              },
            }}
          >
            {translations[language]?.globeButton}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default GlobalStage;
